
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';

import '../../styles/quote.css';

/**
 * Reuseable quote component
 */
export const Quote = ({ by, role, image, children }: {
  by: string,
  role: string,
  image: IGatsbyImageData,
  children: React.ReactNode
}) => {
  const imageData = getImage(image);
  return (
    <blockquote className="quote-container">
      <div className="quote-content">
        {children}
      </div>
      <footer className="quote-footer">
        {!!imageData && (
          <GatsbyImage
            image={imageData}
            alt={by}
            imgClassName='quote-footer-image'
          />
        )}
        <div className="quote-footer-content">
          <span>{by}</span>
          <span>{role}</span>
        </div>
      </footer>
    </blockquote>
  );
};
